export const FACILITIES = [
  {
    text: 'Air conditioning',
    value: 'air_conditioning',
  },
  {
    text: 'Free parking',
    value: 'free_parking',
  },
  {
    text: 'Swimming pool',
    value: 'swimming_pool',
  },
  {
    text: 'Family rooms',
    value: 'family_rooms',
  },
];

export const STARS = Array.from({ length: 5 }, (_, index) => ({
  text: index + 1,
  value: index + 1,
}));
export const SCORE = [].concat(
  [
    {
      text: 'None',
      value: null,
    },
  ],
  Array.from({ length: 3 }, (_, index) => ({
    text: `${index + 7}+`,
    value: index + 7,
  })),
);

export const ACCOMONDATION = [
  {
    text: 'Apartment',
    value: 'Apartment',
  },
  {
    text: 'Hotel',
    value: 'Hotel',
  },
  {
    text: 'Villa',
    value: 'villa',
  },
];

export const SORTING = [
  {
    text: 'Sort by price (low to high)',
    value: '0',
  },
  {
    text: 'Sort by price (high to low)',
    value: '0',
  },
  {
    text: 'Homes and apartments first',
    value: '0',
  },
  {
    text: 'Property rating (high to low)',
    value: '0',
  },
  {
    text: 'Property rating (low to high)',
    value: '0',
  },
  {
    text: 'Distance from city center',
    value: '0',
  },
  {
    text: 'Saved properties first',
    value: '0',
  },
];

export const PRICE = [
  {
    text: '0',
    value: 0,
  },
  {
    text: '100',
    value: 100,
  },
  {
    text: '200',
    value: 200,
  },
  {
    text: '300',
    value: 300,
  },
  {
    text: '400',
    value: 400,
  },
  {
    text: '500',
    value: 500,
  },
  {
    text: '600',
    value: 600,
  },
  {
    text: '700',
    value: 700,
  },
];

export const SORTING_OPTIONS = [
  {
    text: 'None',
    value: null,
  },
  {
    text: 'Price ↓',
    value: {
      by: 'price',
      order: 'asc',
    },
  },
  {
    text: 'Price ↑',
    value: {
      by: 'price',
      order: 'desc',
    },
  },
  {
    text: 'Rating ↓',
    value: {
      by: 'rating',
      order: 'asc',
    },
  },
  {
    text: 'Rating ↑',
    value: {
      by: 'rating',
      order: 'desc',
    },
  },
  {
    text: 'Favorites ↓',
    value: {
      by: 'favorites',
      order: 'asc',
    },
  },
  {
    text: 'Favorites ↑',
    value: {
      by: 'favorites',
      order: 'desc',
    },
  },
];
